import { render } from "./BaseTable.vue?vue&type=template&id=7106ffbc"
const script = {}

import "./BaseTable.vue?vue&type=style&index=0&id=7106ffbc&lang=scss"

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__